import { render, staticRenderFns } from "./ProviderMarketingInfo.vue?vue&type=template&id=6dc8f1f0"
import script from "./ProviderMarketingInfo.vue?vue&type=script&lang=js"
export * from "./ProviderMarketingInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports